export default {
  data() {
    return {
      locale: this.$store.state.locale,
      langContext: this.$t('featureComponents.Header'),
      userNavigationLinks: [
        {
          name: 'Shopping Cart',
          url: '/shopping-cart',
          target: '',
        },
        {
          name: 'My Orders',
          url: '/order/list',
          target: '',
        },
        {
          name: 'Unpaid Courses',
          url: '/my-unpaid-courses/list',
          target: '',
          mark: true,
        },
        {
          name: 'My Account',
          url: '/settings',
          target: '',
        },
        {
          name: 'Sign Out',
          url: '',
          target: '',
          isLink: false,
        },
      ],
      campusNavList: [
        {
          name: 'Cupertino, CA',
          url: '/campuses/cupertino',
          lat: 37.30714227875363,
          lng: -122.03266038727122,
          // lat: 40.1049346951878,
          // lng: 116.30858611791325,
        },
        {
          name: 'Los Altos, CA',
          url: '/campuses/los-altos',
          lat: 37.397233912852286,
          lng: -122.10594913145032,
        },
        {
          name: 'Irvine, CA',
          url: '/campuses/irvine',
          lat: 33.69325888612016,
          lng: -117.76890120274233,
        },
        {
          name: 'Bellevue, WA',
          url: '/bellevue/summer',
          lat: 47.627553569969756,
          lng: -122.17057973103854,
        },
      ],
      longLat: {
        // long: 40.104934698994526,
        // lat: 116.30858611429599,
        long: '',
        lat: '',
      },
      siteJumpUrl: '/', // 站点跳转链接
      schoolName: 'Find my school',
      targetUrl: ['/mathgame', 'https://www.thethinkacademy.com/mathgame'],
      selectedTeachingPoint: {},
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
    userInfo() {
      return this.$store.state.ucenter.user
    },
    currentRoutePath() {
      return this.$route.path
    },
    navigationLinks() {
      return this.$store.state.website.header.navigationLinks
    },
    // 主导航列表
    mainNavList() {
      return this.navigationLinks.filter((item) => (item.navigation && item.navigation === 1) || !item.navigation)
    },
    // 一级导航
    firstNavList() {
      return this.navigationLinks.filter((item) => item.navigation && item.navigation === 3)
    },
    ceilingList() {
      return this.$store.state.customPage.pageModuleList.filter((item) => item.type === 66)
    },
    logoUrl() {
      const { config } = this.$store.state.website || {}
      return process.env.clientType === 'web' ? (config.logo || this.$t('common.logo.normal')) : (config.whiteLogo || this.$t('common.logo.normalWhite'))
    },
    isWebClient() {
      return process.env.clientType === 'web'
    },

    schoolCode() {
      return this.$store.state.schoolCode;
    },
    secondNavList() {
      // 先检查 firstNavList 是否存在
      if (!this.firstNavList) {
        return [];
      }
      // 查找匹配的路由
      const findRoute = this.firstNavList.find((item) => item.url === this.currentRoutePath);
      // 安全地返回子路由列表
      if (findRoute && findRoute.children) {
        return findRoute.children;
      }
      return this.mainNavList;
    },
    excludeMathGame() {
      const deepFilter = (items) => {
        if (!Array.isArray(items)) return []
        return items.reduce((filtered, current) => {
          const shouldExclude = current && current.url && this.targetUrl.includes(current.url)
          if (shouldExclude) {
            return filtered
          }
          const nextItem = { ...current }
          if (Array.isArray(current.children) && current.children.length) {
            nextItem.children = deepFilter(current.children)
          }
          filtered.push(nextItem)
          return filtered
        }, [])
      }
      return deepFilter(this.secondNavList)
    },
    showSchool() {
      const campusNavListUrl = this.campusNavList.map((item) => item.url);
      const targetUrl = [...campusNavListUrl, '/inperson'];
      return targetUrl.includes(this.currentRoutePath);
    },
    teachingPoinsList() {
      return this.$store.state.schoolConfig.schoolTeachingPoints
    },
  },
  watch: {
    currentRoutePath: {
      handler(newVal) {
        if (newVal) {
          const targetSchool = this.campusNavList.find((item) => item.url === newVal);
          if (targetSchool) this.schoolName = targetSchool.name;
        }
      },
      immediate: true,
    },
    teachingPoinsList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.schoolName = this.setDefaultVenue(newVal)
          window.sessionStorage.setItem('triage-desk-venue-name', this.schoolName);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // const schoolName = window.sessionStorage.getItem('triage-desk-venue-name')
    // if (schoolName) {
    //   this.schoolName = schoolName;
    // }
    console.log('this.longLat.long', this.longLat.long, this.longLat.lat)
    console.log('!this.longLat.long && !this.longLat.lat', !this.longLat.long && !this.longLat.lat)
    this.getLocalLongLat();
    if (!this.longLat.long && !this.longLat.lat) {
      this.getLongLat();
    }
  },
  methods: {
    handleClickNav(name) {
      this.Sensors.track('component_click', {
        component_name: name,
      })
    },
    getLongLat() {
      console.log('navigator', navigator)
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showmap, this.error);
      } else {
        sessionStorage.setItem('geoRedirected', 'true');
      }
    },
    showmap(position) {
      const cords = position.coords;
      this.longLat.long = cords.longitude; // 经度
      this.longLat.lat = cords.latitude; // 纬度
      window.sessionStorage.setItem('currentLocationLat', cords.latitude);
      window.sessionStorage.setItem('currentLocationLng', cords.longitude);
      console.log('获取经纬度成功', this.longLat)
    },
    error(error) {
      sessionStorage.setItem('geoRedirected', 'true');
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log('用户拒绝了位置请求');
          break;
        case error.POSITION_UNAVAILABLE:
          console.log('位置信息不可用');
          break;
        case error.TIMEOUT:
          console.log('请求位置超时');
          break;
        case error.UNKNOWN_ERROR:
          console.log('发生未知错误');
          break;
        default:
          console.log('获取失败')
      }
    },
    getLocalLongLat() {
      this.longLat.long = window.sessionStorage.getItem('currentLocationLng'); // 经度
      this.longLat.lat = window.sessionStorage.getItem('currentLocationLat'); // 纬度
    },
    // 设置默认教学点
    setDefaultVenue(centers) {
      console.log('setDefaultVenue header', centers)
      const TeachingPoints = localStorage.getItem('TeachingPoints');
      console.log('TeachingPoints header', TeachingPoints)
      if (TeachingPoints) {
        // 获取centers中venueName === TeachingPoints
        const findVenue = centers.find((item) => item.name === TeachingPoints);
        if (findVenue) {
          return findVenue.name
        }
        // 获取当前定位， 判断centers中的lat lng 距离小于30公里的数据的venueName，如果没有小于30公里的 返回centers中 venueName=== 'online', 如果没有online 返回centers中第一个数据的venueName
        if (this.longLat.lat && this.longLat.long) {
          const userLat = this.longLat.lat;
          const userLng = this.longLat.long;

          // 计算距离并筛选小于30公里的教学点
          const nearbyCenters = centers
            .filter((item) => item.lat && item.lng) // 过滤掉没有经纬度的点
            .map((item) => {
              const distance = this.calculateDistance(
                userLat, userLng,
                item.lat, item.lng,
              );
              return { ...item, distance };
            })
            .filter((item) => item.distance <= 30); // 筛选30公里内的点

          if (nearbyCenters.length > 0) {
            // 按距离排序，返回最近的
            nearbyCenters.sort((a, b) => a.distance - b.distance);
            return nearbyCenters[0].name;
          }
          // 没有近的教学点，尝试返回Online
          const onlineCenter = centers.find((item) => item.name === 'Online');
          return onlineCenter ? onlineCenter.name : centers[0].name;
        }
        // 没有近的教学点，尝试返回Online
        const onlineCenter = centers.find((item) => item.name === 'Online');
        return onlineCenter ? onlineCenter.name : centers[0].name;
      }
      return this.findNearestOrFallbackVenue(centers);
    },
    // 辅助方法：计算两个经纬度点之间的距离（公里）
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // 地球半径（公里）
      // eslint-disable-next-line no-mixed-operators
      const dLat = (lat2 - lat1) * Math.PI / 180;
      // eslint-disable-next-line no-mixed-operators
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        // eslint-disable-next-line no-mixed-operators
        + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180)
        * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // 距离（公里）
      return distance;
    },
    findNearestOrFallbackVenue(centers) {
      if (this.longLat.lat && this.longLat.long) {
        const userLat = this.longLat.lat;
        const userLng = this.longLat.long;

        // 计算距离并筛选小于30公里的教学点
        const nearbyCenters = centers
          .filter((item) => item.lat && item.lng) // 过滤掉没有经纬度的点
          .map((item) => {
            const distance = this.calculateDistance(
              userLat, userLng,
              item.lat, item.lng,
            );
            return { ...item, distance };
          })
          .filter((item) => item.distance <= 30); // 筛选30公里内的点

        console.log('nearbyCenters header', nearbyCenters);
        if (nearbyCenters.length > 0) {
          // 按距离排序，返回最近的
          nearbyCenters.sort((a, b) => a.distance - b.distance);
          return nearbyCenters[0].name;
        }
        // 没有近的教学点，尝试返回Online
        console.log('header 没有近的教学点，尝试返回Online centers', centers[0].name)
        const onlineCenter = centers.find((item) => item.name === 'Online');
        console.log('header if --- onlineCenter', onlineCenter)
        return onlineCenter ? onlineCenter.name : centers[0].name;
      }
      // 没有近的教学点，尝试返回Online
      const onlineCenter = centers.find((item) => item.name === 'Online');
      console.log('header onlineCenter -- else', onlineCenter);
      return onlineCenter ? onlineCenter.name : centers[0].name;
    },
  },
}
